/* eslint-disable import/prefer-default-export */
export { default as Slider } from './Slider';
